import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import Button from "../button/Button";
import phoneMockup from "../../assets/images/phoneMockup.png"; // ganti sesuai file kamu
import whiteLogo from "../../assets/images/white-logo.png"; // ganti sesuai file kamu
import { FaInstagram, FaFacebookF, FaTiktok } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      {/* === Kontak Kami Section === */}
      <section className="section-shell overflow-hidden bg-white">
        <div className="container mx-auto flex flex-col items-center justify-between gap-12 px-4 sm:px-6 md:flex-row lg:px-8">
          {/* Left Text */}
          <div className="md:w-1/2 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-4">
              {/* <Plus className="text-blue-600" size={18} /> */}
              {/* <span className="text-blue-600 font-semibold text-sm">
                Kontak Kami
              </span> */}
            </div>

            <span className="section-eyebrow mb-5">Mulai sekarang</span>
            <h2 className="mb-4 text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl md:text-5xl">
              Temukan Solusi Keuangan untuk{" "}
              <span className="text-[#2458d3]">Anda</span>
            </h2>
            <p className="mb-8 text-lg text-slate-600">
              Cukup satu platform, semua pilihan tersedia
            </p>

            <a
              href={`${process.env.REACT_APP_API_URL}/download/aplikasi/tomi-101.apk`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="primary"
                className="bg-[#3f6fe5] text-white hover:bg-[#2f5fd8] px-6 py-3"
              >
                Download Sekarang
              </Button>
            </a>
          </div>

          {/* Right Image */}
          <div className="flex justify-center md:w-1/2">
            <img
              src={phoneMockup}
              alt="Tomi App"
              className="max-w-[240px] object-contain drop-shadow-2xl transition-transform duration-500 hover:-translate-y-2 md:max-w-[300px]"
            />
          </div>
        </div>
      </section>

      {/* === Footer Section === */}
      <div className="relative overflow-hidden bg-[#3f6fe5] py-16 text-white">
        <div className="relative container mx-auto grid gap-10 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:gap-12 lg:px-8">
          {/* Logo & Deskripsi */}
          <div>
            <img src={whiteLogo} alt="Tomi Logo" className="h-10 mb-4" />
            <p className="mb-5 text-sm leading-relaxed text-white/85">
              Platform aggregator keuangan yang menyatukan berbagai penyedia
              layanan terpercaya, membantu Anda mengambil keputusan finansial
              yang tepat, cepat, dan aman.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/tokomikro.id/"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-white/10 p-2.5 transition-all hover:-translate-y-0.5 hover:bg-white/20"
              >
                <FaInstagram size={16} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61575624527998"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-white/10 p-2.5 transition-all hover:-translate-y-0.5 hover:bg-white/20"
              >
                <FaFacebookF size={16} />
              </a>
              <a
                href="https://www.tiktok.com/@tokomikro.id?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-white/10 p-2.5 transition-all hover:-translate-y-0.5 hover:bg-white/20"
              >
                <FaTiktok size={16} />
              </a>
            </div>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-semibold mb-4">Our Pages</h4>
            <ul className="space-y-3 text-sm text-white/85 [&_a]:transition-colors [&_a:hover]:text-white">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/service">Service</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm text-white/85 [&_a]:transition-colors [&_a:hover]:text-white">
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service">Term Of Services</Link>
              </li>
              <li>
                <Link to="/disclaimer">Disclaimer</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Get In Touch</h4>
            <ul className="space-y-3 text-sm text-white/85 [&_a]:transition-colors [&_a:hover]:text-white">
              <li className="flex items-center gap-2">
                <Phone size={14} />{" "}
                <a target="_blank" rel="noreferrer" href="https://wa.me/6281111181888">
                  +62 811-1118-1888
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} />
                <a href="mailto:cs@tokomikro.id">cs@tokomikro.id.</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1" />
                PT TOKO MIKRO INDONESIA <br />
                {/*  */}
                Jl. Kemang Raya No.4, RT.11/RW.1,
                <br />
                Bangka, Kec. Mampang Prpt., Kota Jakarta Selatan,
                <br />
                Daerah Khusus Ibukota Jakarta 12730
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
